import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-user-survery', {
  mixins: [eventListenerMixin],

  connected() {
    this.listenTo(this.querySelector('.button-warning'), 'click', this.handleClick.bind(this));
    this.listenTo(this.querySelector('#user-survery-cancel'), 'click', this.handleClick.bind(this));
  },

  handleClick() {
    this.classList.remove('active');
    setTimeout(() => {
      this.remove();
    }, 500);

    $.ajax({
      url: '/new_feature_confirmations',
      method: 'post',
      data: {
        metadata_key: 'had_confirmed_user_survery',
      },
    });
  },

  ready() {
    setTimeout(() => {
      this.classList.add('active');
    }, 1000);
  },

  disconnected() {
    this.stopListening();
  },
});
